// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PublicSchemaTypes from '../../../graphql/public/PublicSchemaTypes';

import { UserDetailFragment } from '../../../public-api/hooks/usePublicApiSession.codegen';
import { UserVerificationDetailFragment } from '../verification-user-form-step/Verification.codegen';
import { gql } from '@apollo/client';
import { UserDetailFragmentDoc } from '../../../public-api/hooks/usePublicApiSession.codegen';
import { UserVerificationDetailFragmentDoc } from '../verification-user-form-step/Verification.codegen';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type LoginMutationVariables = PublicSchemaTypes.Exact<{
  password: PublicSchemaTypes.Scalars['String'];
  accountNameOrEmail: PublicSchemaTypes.Scalars['NonEmptyString'];
}>;


export type LoginMutation = (
  { __typename?: 'Mutation' }
  & { login?: PublicSchemaTypes.Maybe<(
    { __typename?: 'UserSessionModelSelf' }
    & Pick<PublicSchemaTypes.UserSessionModelSelf, 'expires' | 'created_at'>
    & { user: (
      { __typename?: 'UserModelSelf' }
      & UserDetailFragment
    ) }
  )> }
);

export type GetUserSecurityQuestionsQueryVariables = PublicSchemaTypes.Exact<{
  accountName: PublicSchemaTypes.Scalars['NonEmptyString'];
}>;


export type GetUserSecurityQuestionsQuery = (
  { __typename?: 'Query' }
  & Pick<PublicSchemaTypes.Query, 'getUserSecurityQuestions'>
);

export type UserByCredentialsMutationVariables = PublicSchemaTypes.Exact<{
  accountNameOrEmail: PublicSchemaTypes.Scalars['NonEmptyString'];
  password: PublicSchemaTypes.Scalars['NonEmptyString'];
}>;


export type UserByCredentialsMutation = (
  { __typename?: 'Mutation' }
  & { userByCredentials?: PublicSchemaTypes.Maybe<(
    { __typename?: 'UserModelBase' }
    & Pick<PublicSchemaTypes.UserModelBase, 'organisation_role'>
    & UserVerificationDetailFragment
  )> }
);


export const LoginDocument = gql`
    mutation login($password: String!, $accountNameOrEmail: NonEmptyString!) {
  login(password: $password, accountNameOrEmail: $accountNameOrEmail) {
    user {
      ...userDetail
    }
    expires
    created_at
  }
}
    ${UserDetailFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      password: // value for 'password'
 *      accountNameOrEmail: // value for 'accountNameOrEmail'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const GetUserSecurityQuestionsDocument = gql`
    query getUserSecurityQuestions($accountName: NonEmptyString!) {
  getUserSecurityQuestions(accountName: $accountName)
}
    `;

/**
 * __useGetUserSecurityQuestionsQuery__
 *
 * To run a query within a React component, call `useGetUserSecurityQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSecurityQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSecurityQuestionsQuery({
 *   variables: {
 *      accountName: // value for 'accountName'
 *   },
 * });
 */
export function useGetUserSecurityQuestionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserSecurityQuestionsQuery, GetUserSecurityQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserSecurityQuestionsQuery, GetUserSecurityQuestionsQueryVariables>(GetUserSecurityQuestionsDocument, options);
      }
export function useGetUserSecurityQuestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserSecurityQuestionsQuery, GetUserSecurityQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserSecurityQuestionsQuery, GetUserSecurityQuestionsQueryVariables>(GetUserSecurityQuestionsDocument, options);
        }
export type GetUserSecurityQuestionsQueryHookResult = ReturnType<typeof useGetUserSecurityQuestionsQuery>;
export type GetUserSecurityQuestionsLazyQueryHookResult = ReturnType<typeof useGetUserSecurityQuestionsLazyQuery>;
export type GetUserSecurityQuestionsQueryResult = Apollo.QueryResult<GetUserSecurityQuestionsQuery, GetUserSecurityQuestionsQueryVariables>;
export const UserByCredentialsDocument = gql`
    mutation userByCredentials($accountNameOrEmail: NonEmptyString!, $password: NonEmptyString!) {
  userByCredentials(accountNameOrEmail: $accountNameOrEmail, password: $password) {
    ...userVerificationDetail
    organisation_role
  }
}
    ${UserVerificationDetailFragmentDoc}`;
export type UserByCredentialsMutationFn = Apollo.MutationFunction<UserByCredentialsMutation, UserByCredentialsMutationVariables>;

/**
 * __useUserByCredentialsMutation__
 *
 * To run a mutation, you first call `useUserByCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserByCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userByCredentialsMutation, { data, loading, error }] = useUserByCredentialsMutation({
 *   variables: {
 *      accountNameOrEmail: // value for 'accountNameOrEmail'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useUserByCredentialsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserByCredentialsMutation, UserByCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserByCredentialsMutation, UserByCredentialsMutationVariables>(UserByCredentialsDocument, options);
      }
export type UserByCredentialsMutationHookResult = ReturnType<typeof useUserByCredentialsMutation>;
export type UserByCredentialsMutationResult = Apollo.MutationResult<UserByCredentialsMutation>;
export type UserByCredentialsMutationOptions = Apollo.BaseMutationOptions<UserByCredentialsMutation, UserByCredentialsMutationVariables>;